<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", ["to_be"])
  },

  methods: {
    ...mapActions("newPurchase", ["setToBe"])
  }
};
</script>

<template>
  <div id="tobe" class="section">
    <div class="section-title">VOCÊ DESEJA QUE A LIMPEZA SEJA
      <hr>
    </div>

    <div class="section-body">
      <div
        class="btn bg-pink"
        :class="{'bg-pink': to_be !== 'professional', 'bg-gray': to_be === 'professional'}"
        @click="setToBe('schedule'); $emit('scrollTo', '#PerSchedule')"
      >em um dia específico</div>

      <div
        class="btn"
        :class="{'bg-pink': to_be !== 'schedule', 'bg-gray': to_be === 'schedule'}"
        @click="setToBe('professional'); $emit('scrollTo', '#PerProfessional')"
      >com um profissional favorito</div>
    </div>
  </div>
</template>

<style scoped>
.section-body {
  display: flex;
  flex-direction: row;
}

.btn {
  flex: 1;
  width: 200px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/ToBe.vue